/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request model for initializing a video upload.  Attributes:     title (str): The title of the video.     description (str): The description of the video.     gender (str): The gender of the video.     category (str): The category of the video.     competition (str): The competition of the video.
 */
export interface InitializeUploadRequest { 
    title: string;
    description: string;
    gender: string;
    category: string;
    competition: string;
    duration_in_seconds?: number;
    youtube_url?: string | null;
    season_id?: number | null;
    match_date?: string | null;
}

